import { render, staticRenderFns } from "./AlterationApplications.vue?vue&type=template&id=d3824a4a&scoped=true&"
import script from "./AlterationApplications.vue?vue&type=script&lang=js&"
export * from "./AlterationApplications.vue?vue&type=script&lang=js&"
import style0 from "./AlterationApplications.vue?vue&type=style&index=0&id=d3824a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3824a4a",
  null
  
)

export default component.exports